import {api} from "../api.slice";
import Faq from "@/types/faq";
import { apiEndpoints } from "@/utils/api-endpoints";


const faqApi = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getFaqs: builder.query<Faq[], void>({
            query: () => apiEndpoints.Faq.GetAll.url,
            providesTags: ['Faqs'],
        }),
        getFaq: builder.query<Faq, number>({
            query: (id) => `${apiEndpoints.Faq.GetAll.url}/${id}`,
            providesTags: ['Faqs'],
        }),
        createFaq: builder.mutation<Faq, Omit<Faq, 'id'>>({
            query: (body) => ({
                url: apiEndpoints.Faq.Add.url,
                method: apiEndpoints.Faq.Add.method,
                body,
            }),
            invalidatesTags: ['Faqs'],
        }),
        updateFaq: builder.mutation<Faq, Faq>({
            query: (body) => ({
                url: apiEndpoints.Faq.Edit.url(String(body.id)),
                method: apiEndpoints.Faq.Edit.method,
                body,
            }),
            invalidatesTags: ['Faqs'],
        }),
        deleteFaq: builder.mutation<Faq, number>({
            query: (id) => ({
                url: apiEndpoints.Faq.Delete.url(String(id)),
                method: apiEndpoints.Faq.Delete.method,
            }),
            invalidatesTags: ['Faqs'],
        }),
    }),
});

export const {
    useGetFaqsQuery,
    useGetFaqQuery,
    useCreateFaqMutation,
    useUpdateFaqMutation,
    useDeleteFaqMutation,

} = faqApi